import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import { QuickAppointmentContext } from '../../Context';
import useStyles from '../styles';

const Contact = () => {
  const { contactData } = useContext(QuickAppointmentContext);

  const classes = useStyles();

  return (
    <div className={classes.main}>
      <Typography className={classes.typography} variant="caption">
        {contactData.first_name} {contactData.last_name}
      </Typography>
      <Typography className={classes.typography} variant="caption">
        {contactData.email}
      </Typography>
      <Typography className={classes.typography} variant="caption">
        {contactData.phone}
      </Typography>
    </div>
  );
};

export default Contact;
